































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Mutation, Getter } from 'vuex-class';
import {
  Button, Scrollbar, Rate, Input, Message, Dialog,
} from 'element-ui';
import NProgress from 'nprogress';

import Header from '@/components/nav/VocabularyTop.vue';
import MyDialog from '@/components/dialog/Index.vue'; // dialog
import Force from '@/components/force/newForce.vue'; // new force

import WordDetail from '@/servers/modules/vocabulary/worddetail'; // server
import Word from '@/servers/modules/vocabulary/wordlist'; // server
import Vocabulary from '@/servers/modules/vocabulary/vocabulary'; // server
import log from '@/servers/modules/vocabulary/log';
import { OnGetOS, handleClickToAppfuncation } from '@/plugins/util'
import VoiceEvaluationService from '@/utils/voice-evaluation';

@Component({
  components: {
    Header,
    Scrollbar,
    Rate,
    Button,
    Force,
    MyDialog,
    Input,
    Dialog,
  },
})
export default class extends Vue {
  // ==============================数据==================================
  // ------------------------------数据
  courseName!: string;

  /* 课程名称 */
  difficuteInfo: number = 0;

  /* 单词星级 */
  wordData: string[] = [];

  /* 练一练数组 */
  practice = '';

  /* 编辑助记语及练一练 当前输入值 */
  data: any;

  /* 当前词汇所有数据 */
  courseWordId = '';

  /* 路由参数 */
  voiceCount!: number;

  /* 口语测评次数 */
  voiceScore = 0;

  /* 口语测评分数 */
  nowWordId = '';

  /* 当前词汇id */
  timer: number | undefined;

  /* 语音测评倒计时 */
  count = 55;

  /* 语音测评倒计时一分钟 */
  voiceSrc = '' /* 语音测评上一次读音 */
  errCode:any = "" /* 是否显示口语得分 */
  EvalMode:any = '' /* 词语是单词还是短句 */
  recorder:any

  // ------------------------------控制
  addTroubleWordIs = true;

  ebopoOS = 'andriod'

  /* 单词读音图标切换 */
  // 口语评测
  dialogVoice = false;

  /* 弹窗 */
  currentWordIsSingle = true;


  /* 单词读音图标切换 */
  isvoiceCollect = false;

  /* 是否正在录音 */
  isvoicePlay = false;

  /* 是否正在播放上一次录音 */
  isHaveRecord = false;

  /* 是否有录音 */
  flagScore = false; /* 是否显示口语得分 */

  // @ts-ignore 打开弹窗
  @Mutation public openDialog:any;

  // @ts-ignore 关闭弹窗
  @Mutation public closeDialog: any;

  // @ts-ignore 页面加载
  @Mutation public setSkeletonDescribe:any;

  // @ts-ignore 页面加载
  @Getter public skeleton: any;

  // ------------------------------监听
  @Watch('count')
  onChangeValue(newVal: number) {
    if (newVal <= 0 && this.isvoiceCollect == true) {
      this.stopRecording();
    }
  }

  @Watch('dialogVoice')
  onChangedialogVoice(newVal: boolean) {
    if (newVal == false) {
      if (this.isvoiceCollect) {
        this.stopRecording();
      }
    }
  }

  @Watch('EvalMode')
  onChangeEvalMode(newVal: any, oldVal: any){    
    console.log('newVal',newVal)
    console.log('oldVal',oldVal)
    if (newVal != oldVal && oldVal != '') {
      console.log('come in')
      this.initTencentSOE()
      // this.recorder.reset({
      //   EvalMode: newVal
      // });
    }
  }

  // ==============================初始化==================================
  created() {    
    let os = OnGetOS()
    if (os == 'iphone') {
      this.ebopoOS = 'iphone'
    }

    this.setSkeletonDescribe(true);
    NProgress.start();
    // 课程名称
    this.courseName = window.LS.get('basicData').courseName;

    this.courseWordId = this.$route.query.courseWordId;
    this.nowWordId = this.$route.query.courseWordId;
    // 单词详情
    this.getWordDetail();
  }

  // 单词详情
  async getWordDetail() {
    const data = {
      courseId: window.LS.get('vteData').course.courseId,
      userId: window.LS.get('vteData').user.userId,
      courseWordId: this.courseWordId,
      inputWay: this.$route.query.inputWay,
    };
    this.apiNextPre(data, () => {
      NProgress.done();
      this.setSkeletonDescribe(false);
    }, true);
  }

  // ==============================语音评测==================================
  // ------------------------------初始化
  initVoice(first:boolean) {   
    this.EvalMode = this.currentWordIsSingle == true ? 0 : 1;
    console.log('EvalMode',this.EvalMode)    
    if (first) {
      this.initTencentSOE(first)
    }    
  }

  initTencentSOE (first?:boolean) {
    let that = this;   
    this.$nextTick(() => {

      this.getTTSToken(null).then((res: any) => {
        let result = JSON.parse(res.data.data);        
        this.recorder = new VoiceEvaluationService({
          
          // StorageMode: 1, /* 是否获取存储MP3文件链接 */
          EvalMode: that.EvalMode,
          getAuthorization(callback: any) {
            callback({
              Token: result.Credentials.Token,
              TmpSecretId: result.Credentials.TmpSecretId,
              TmpSecretKey: result.Credentials.TmpSecretKey,
              ExpiredTime: result.ExpiredTime
            });
          },
          success() {
            console.log('success')
          },
          error: function t(e:any) {
            if (first) {
              that.errCode = e.code;
              console.log('error', e)
            }
          },
        });

        console.log('this.recorder',that.recorder)

      });

    })     
  }

  // 检测是否有麦克风权限
  checkoutPermission() {        

    if (this.errCode == 10001) {
      Message({ message: "当前浏览器不支持录音功能，请升级或更换浏览器", type: "error" });  
      return false
    } else if (this.errCode == 10002) {
      Message({ message: "未开启麦克风访问权限", type: "error" });    
      return false    
    }

    this.dialogVoice = true
  }

  // ------------------------------api-语音评测
  // 获取Token；TmpSecretId；TmpSecretKey；ExpiredTime
  async getTTSToken(data: any) {
    return await Vocabulary.getTTSToken(data);
  }

  //
  async voiceCountNum(data: any) {
    return await WordDetail.voiceCountNum(data);
  }

  // 倒计时一分钟
  timerMinute() {
    this.count = 55;
    this.timer = setInterval(() => {
      if (this.count > 0 && this.count <= 55) {
        this.count -= 1;
      } else {
        clearInterval(this.timer);
      }
    }, 1000);
  }

  // ------------------------------开始口语录音
  playRecording(word: any) {
    if (this.voiceCount <= 0) {
      Message({ message: '语音测评次数不足', type: 'error' });
      return false;
    }

    if (this.isvoicePlay == true) {
      this.isvoicePlay = false;
      this.stopVoice();
    }
    this.isHaveRecord = false;
    this.timerMinute();
    this.isvoiceCollect = true;
    const that = this;
    this.recorder.start({
      RefText: word,
      error(err:any) {
        console.log('voice start error', err);
        that.isvoiceCollect = false;
        clearInterval(that.timer);
        Message({ message: (err && (err.message || err.code)) || '语音测评启动失败', type: 'error' });
      },
    });
  }

  // ------------------------------结束口语录音
  stopRecording() {
    this.isvoiceCollect = false;
    const that = this;
    clearInterval(this.timer);
    const params = {
      courseId: window.LS.get('vteData').course.courseId,
      courseWordId: this.nowWordId,
    };
    this.recorder.stop({
      success(res: any) {
        setTimeout(() => {
          const audioUrl = res.blob ? URL.createObjectURL(res.blob) : ''; //输出音频url
          console.log('audioUrl',audioUrl);
          that.voiceSrc = audioUrl
          // that.voiceSrc = res.AudioUrl;
        }, 1000);
        // 输出测评结果

        that.voiceScore = parseInt(res.SuggestedScore);
        that.dialogVoice = false;
        that.flagScore = true;

        that.voiceCountNum(params).then((res) => {

          that.voiceCount = res.data.data.oralNum;
        });
      },
      error(err: any) {
        console.log('voice stop error', err);
        Message({ message: (err && (err.message || err.code)) || '语音测评失败', type: 'error' });
      },
    });
  }

  // ------------------------------播放上一次口语录音
  playVoice() {
    this.isvoicePlay = true;
    this.$refs.voiceTest.play();
  }

  // ------------------------------暂停上一次口语录音
  stopVoice() {
    this.isvoicePlay = false;
    this.$refs.voiceTest.pause();
    this.$refs.voiceTest.currentTime = 0;
  }

  // ------------------------------上一次口语录音播放结束
  voiceEnd() {
    this.isvoicePlay = false;
  }

  beforeDestroy() {
    // navigator.mediaDevices.getUserMedia({ audio: true, video: false })
    //   .then((mediaStream) => {
    //   // Stop the stream after 1 seconds
    //     setTimeout(() => {
    //       const tracks = mediaStream.getTracks();
    //       tracks[0].stop();
    //     }, 1000);
    //   });
  }

  // ==============================操作==================================
  // 触发（练一练 & 编辑助记语）
  private operat(operating: string) {
    this.practice = '';
    const obj:any = {
      visible: true,
      titleClose: true,
      titleIcon: false,
      type: operating,
      longText: '',
      text: '',
      footer: [],
    };
    if (operating == 'editMnemonic') {
      obj.text = '编辑助记语';
      obj.titleIcon = false;

      obj.longText = (this.data.wordInfoVo.studentMnemonicTips
          && this.data.wordInfoVo.studentMnemonicTips.content)
        || '未填写';
      obj.footer = [
        {
          class: 'button-style-border',
          word: '关闭',
        },
        {
          class: 'button-style-background',
          word: '保存提交',
        },
      ];
    } else if (operating == 'practice') {
      obj.text = '练一练';
      obj.titleIcon = false;
      // 重新开始练一练
      this.wordData = [];
      delete obj.footer;
    }
    this.openDialog(obj);
  }

  // ------------------------------练一练
  enterWord() {
    // 输入等于 原本的内容
    const obj: any = {};
    obj.practice = this.practice;
    obj.image = require('@/assets/images/word-yes.png');
    if (this.practice != this.data.word) {
      obj.image = require('@/assets/images/word-fail.png');
    }
    if (this.wordData.length < 5) {
      this.wordData.push(obj);
      this.practice = '';
    }
  }

  // ------------------------------编辑助记语
  async dialogHandle(index:number) {
    if (index == 0) {
      this.closeDialog();
    } else if (index == 1) {
      if (this.practice.trim() == '') {
        Message({ message: '请填写助记', type: 'error' });
        return false;
      }
      // 添加助标
      const obj = {
        courseId: window.LS.get('vteData').course.courseId,
        courseWordId: this.data.id,
        mnemonic: this.practice.trim(),
        userId: window.LS.get('vteData').user.userId,
      };
      const res = await WordDetail.addStudentMnemonic(obj);
      if (!res.data.code) {
        this.data.wordInfoVo.studentMnemonicTips = res.data;
        Message({ message: '助记填写成功', type: 'success' });
        // 添加成功操作赋值
        this.data.wordInfoVo.studentMnemonicTips.content = obj.mnemonic;
        this.data.zj = this.practice.trim();
        this.closeDialog();
      } else {
        Message({ message: res.data.message, type: 'error' });
      }
    }
  }

  // ------------------------------切换生词本
  async toggleStrange(data: any) {
    if (data == 'jiaru') {
      const data = {
        courseId: window.LS.get('vteData').course.courseId,
        operType: 0,
        userCourseWordId: this.data.wordInfoVo.userCourseWordId,
        userId: window.LS.get('vteData').user.userId,
        // troubleWordId: scope.row.troubleWordId,
      };
      const res = await Word.addOrRemoveTroubleWord(data);
      Message({ message: '成功加入生词本', type: 'success' });
      this.addTroubleWordIs = false;
    } else if (data == 'yichu') {
      const data = {
        courseId: window.LS.get('vteData').course.courseId,
        operType: 1,
        userCourseWordId: this.data.wordInfoVo.userCourseWordId,
        userId: window.LS.get('vteData').user.userId,
        // troubleWordId: scope.row.troubleWordId,
      };
      const res = await Word.addOrRemoveTroubleWord(data);
      Message({ message: '成功移出生词本', type: 'success' });
      this.addTroubleWordIs = true;
    }
  }


  // ------------------------------下一词 上一词
  clickNext() {
    const data = {
      courseId: window.LS.get('vteData').course.courseId,
      userId: window.LS.get('vteData').user.userId,
      courseWordId: this.data.nextCourseWordId,
      inputWay: this.$route.query.inputWay,
    };
    this.nowWordId = this.data.nextCourseWordId;
    this.apiNextPre(data, () => { this.$forceUpdate(); }, false);
  }

  clickPre() {
    const data = {
      courseId: window.LS.get('vteData').course.courseId,
      userId: window.LS.get('vteData').user.userId,
      courseWordId: this.data.prevCourseWordId,
      inputWay: this.$route.query.inputWay,
    };
    this.nowWordId = this.data.prevCourseWordId;
    this.apiNextPre(data, () => { this.$forceUpdate(); }, false);
  }

  // ------------------------------接口-下一词 上一词
  async apiNextPre(params: any, callback: Function, first: boolean) {
    const res = await WordDetail.getWordDetail(params);
    this.data = res.data.data;

    this.isHaveRecord = false;
    this.voiceCount = res.data.data.wordInfoVo.oralNum;
    // 星级
    this.difficuteInfo = this.data.wordInfoVo.difficuteInfo;

    // 判断当前是否为单词
    if (this.data.word.indexOf(' ') == -1) {
      this.currentWordIsSingle = true;
    } else {
      this.currentWordIsSingle = false;
    }
    // 生词
    if (this.data.wordInfoVo.addTroubleWordIs) {
      this.addTroubleWordIs = false;
    } else {
      this.addTroubleWordIs = true;
    }
    // 语音评测初始化
    if (this.ebopoOS == 'andriod') {
      this.initVoice(first);
    }

    callback();
  }

  // ------------------------------切换释义
  interpretationSwitch(item:any) {

    let interpretation = '';
    // 第一次进来是默认没有的undefined,变成中文释义
    if (item.interpretation == undefined) {
      interpretation = 'Chinese';
    } else if (item.interpretation == 'English') {
      interpretation = 'Chinese';
    } else if (item.interpretation == 'Chinese') {
      interpretation = 'English+Chinese';
    } else if (item.interpretation == 'English+Chinese') {
      interpretation = 'English';
    }
    this.$set(item, 'interpretation', interpretation);
    this.$forceUpdate();
  }

  // ------------------------------播放读音
  playSound(soundUrl: any) {   
    let isapp = localStorage.getItem('isapp')  
    let os = OnGetOS()

    if (isapp == 'android') {
      handleClickToAppfuncation('playSound',soundUrl)
    }else {
      this.$refs.audio.src = soundUrl;
      this.$refs.audio.play();
    }
  }

}
